<template>
  <el-dialog
    top="0" 
    :visible.sync="value" 
    :show-close="false"
    :width="width || '30%'" 
    :close-on-click-modal="false" 
    :close-on-press-escape="false"
    :append-to-body="true"
    @closed="closed"
    custom-class="popover-dialog"
  >
    <slot name="close">
      <a class="guanbi-con" title="关闭当前">
        <i class="iconfont iconguanbi" @click="close"></i>
      </a>
      <a class="guanbi-con guanbi-con-1" title="关闭全部" v-if="isShowAll">
        <i class="iconfont iconguanbi1" @click="closeAll"></i>
      </a>
    </slot>
    <div class="modify-container">
      <slot></slot>
    </div>
  </el-dialog>
</template>
<script>
export default {
    name: 'PopoverRight',
    props: {
      width: String,
      isShowAll: {
        type: Boolean,
        default: true
      },
      value: {
        type: Boolean,
        default: false
      },
      closed: {
        type: Function,
        default: () => {}
      },
      completeClose: {
        type: Function
      }
    },
    methods: {
      close () {
        // this.$emit('input', false);
        this.closed && this.closed();
      },
      closeAll () {
        if (this.completeClose) {
          this.completeClose && this.completeClose();
        } else {
          this.$EventBus.$emit('dialogChangeCall', {category: '', params: {clearAll: true}});
        }
      }
    }
}
</script>
<style lang="less">
.popover-dialog.el-dialog{
  margin: 0 0 0 5%;
  border-radius: 2px 0 0 2px;
  height: 100VH;
  box-sizing: border-box;
  overflow-y: scroll;
  background: transparent;
  box-shadow: none;
  margin-right: 0;
  height: 100VH;
  overflow-y: scroll;
  float: right;
  .scrollbar();
  .el-dialog__header{
    padding: 0;
  }
  .el-dialog__body{
    padding: 0;
    position: relative;
  }
  .modify-container{
    margin-left: 40px;
    background: #FFF;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    height: 100VH;
    overflow-y: scroll;
    position: relative;
  }
  .guanbi-con{
    background-color: @colorBlue;
    position: absolute; 
    width: 40px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    left: 0;
    top: 0;
    border-radius: 5px 0 0 5px;
    cursor: pointer;
    .iconfont{
      font-size: 25px;
      color: #FFF;
      display: block;
    }
  }
  .guanbi-con-1{
    top: 48px;
    background: #222;
    .iconfont{
      font-weight: bold;
      font-size: 30px;
    }
  }
}
.popover-dialog{
  .el-dialog__wrapper{
      display: -webkit-box;
      -webkit-box-align: end;
      -webkit-box-pack: end;
  }
  .el-dialog__header{
    padding: 0;
  }
  
}
@keyframes dialog-fade-in {
  0% {
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
  100% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  100% {
    transform: translate3d(100%, 0, 0);
    opacity: 0;
  }
}
</style>